const activitySentiments = [
  { icon: "HeartEyes", label: "Love", value: "love" },
  { icon: "SlightSmile", label: "Like", value: "like" },
  { icon: "ThumbsDown", label: "Pass", value: "pass" },
];

export default activitySentiments
